import { Instance } from 'mobx-state-tree'
import { UserGameScheduleModelBase } from './UserGameScheduleModel.base'

/* The TypeScript type of an instance of UserGameScheduleModel */
export interface UserGameScheduleModelType extends Instance<typeof UserGameScheduleModel.Type> {}

/* A graphql query fragment builders for UserGameScheduleModel */
export {
  selectFromUserGameSchedule,
  userGameScheduleModelPrimitives,
  UserGameScheduleModelSelector
} from './UserGameScheduleModel.base'

/**
 * UserGameScheduleModel
 */
export const UserGameScheduleModel = UserGameScheduleModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
